module.exports = __webpack_public_path__ + "media/img/favicon-25eb8047ea369f38e0b20f310e003f86.ico";